import React from 'react';
import { FiArrowDown, FiBookOpen } from 'react-icons/fi';
import Section from './Section.jsx';
import { DocSections } from '../../../const/documentation-const.ts';

export default function Documentation() {
  return (
    <div className="page documentation-page">
      <header className="docs-hero">
        <div className="eyebrow"><FiBookOpen aria-hidden="true" /> Software guide</div>
        <h1>From raw data to<br /><span>explainable insight.</span></h1>
        <p>Follow the complete Neurorule workflow. Each step pairs practical guidance with a real view of the desktop application.</p>
        <a className="button button-primary" href="#getting-started">Start exploring <FiArrowDown /></a>
      </header>

      <nav className="docs-index" aria-label="Documentation sections">
        {DocSections.map((section) => <a key={section.id} href={`#${section.id}`}><small>{String(section.index + 1).padStart(2, '0')}</small>{section.title}</a>)}
      </nav>

      <div className="docs-content">
        {DocSections.map((section) => <Section section={section} key={section.id} />)}
      </div>
    </div>
  )
}
